import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=47c22778&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=47c22778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c22778",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47c22778')) {
      api.createRecord('47c22778', component.options)
    } else {
      api.reload('47c22778', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=47c22778&scoped=true&", function () {
      api.rerender('47c22778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20Z88rdiB0J6i/JS/comp/GuestBox.vue"
export default component.exports